export default __webpack_public_path__ + "static/media/bakat.5b2c9376.png";